import { ButtonError, ButtonSecondaryOutlined } from '@flatsy/core/MaterialUi/Button'
import i18n from '@flatsy/utils/translations'
import { Link } from '@material-ui/core'
import React from 'react'
import { generatePath, NavLink } from 'react-router-dom'
import * as ROUTES from 'src/constants/Routes'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { useMobile } from 'src/hooks/Mobile'
import useHightlight from './Hooks'
import LoadingsSlot from './Loading'
import HightlightSlot from './Slot'
import useStyles from './Style'
import { componentsProps } from './Type'

const HightlightSlots: React.FC<componentsProps> = ({
  handleClickOnSlot,
  showWeeks,
  slots,
  loading,
}): React.ReactElement => {
  const isMobile = useMobile()
  const classes = useStyles()
  const {
    application: { application },
  } = useApplicationDetails()
  const { hightlightSlots } = useHightlight(slots)
  if (loading) {
    return <LoadingsSlot />
  }

  return (
    <div className={classes.slotContainer}>
      {hightlightSlots.map((slot) => (
        <HightlightSlot hightlightSlot={slot} handleClickOnSlot={handleClickOnSlot} />
      ))}
      <ButtonSecondaryOutlined className={classes.button} onClick={showWeeks}>
        {i18n.t('see_more_time_slots')}
      </ButtonSecondaryOutlined>

      {isMobile && application.id && (
        <Link
          component={NavLink}
          to={{
            pathname: generatePath(ROUTES.APPLICATION_DOSSIER_CANCEL, {
              applicationId: application.id,
            }),
          }}
        >
          <ButtonError className={classes.button}>{i18n.t('cancel_my_application')}</ButtonError>
        </Link>
      )}
    </div>
  )
}

export default HightlightSlots
